export const PRODUCT_TYPE = 'productType'
